/* © 2018-2022 TakuLabs Ltd. All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential */

import { GenericPhone } from "../phone-shared/GenericPhone";

export class PersonPhone implements GenericPhone {
  id: number;
  phoneType: PersonPhoneType;
  countryIsoCode: string;
  tel: string;
  ext: string;

  constructor() {
    this.id = 0;
    this.phoneType = PersonPhoneType.home;
    this.countryIsoCode = "";
    this.tel = "";
    this.ext = "";
  }
}

export enum PersonPhoneType {
  mobile = "Mobile",
  home = "Home",
  work = "Work",
  fax = "Fax",
  other = "Other",
}

/* © 2018-2022 TakuLabs Ltd. All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential */
